import React, { useEffect, useRef } from "react";
import "../styles.css";
import "./css/urbanDesktop.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import DeskBg from "../images/city.png";
import PortraitBg from "../images/city-portrait.png";

// import RingImg from "./images/bridal-ring.png";
import RingImg from "../images/gold-ring.png";
import Colier from "../images/Colier-banner.png";
import Slider from "react-slick";
import logo from "../images/teilor-logo.svg";
import sanya from "../images/sanya2.webp";
import sanyaMobile from "../images/sanya.webp";

import "../slick-variable.css";
import "../slick-theme.min.css";
import "../slick.min.css";

export default function UrbanDesktop() {
  gsap.registerPlugin(ScrollTrigger);

  const settings = {
    className: "slider variable-width one-column-mobile",
    arrows: false,
    rows: 1,
    infinite: true,
    slidesToShow: 3.2,
    slidesToScroll: 3,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          centerMode: false,
          arrows: false,
          infinite: true,
          draggable: true,
          swipeToSlide: false,
          touchMove: true,
          rows: 1,
          slidesToShow: 1.6,
          slidesToScroll: 2
        }
      }
    ]
  };
  let bridalBtnRef = useRef(null);

  let backgroundBridalTrigger = useRef(null);
  let backgroundBridal = useRef(null);
  let headerBridalHide = useRef(null);
  let triggerUrbanima = useRef(null);
  let headerRightBridal = useRef(null);
  let headerRightBridalPortrait = useRef(null);

  let sanyaGray = useRef(null);
  let sanyaMobileGray = useRef(null);

  let urb = useRef(null);
  let urb2 = useRef(null);
  let urbSpanRef = useRef(null);

  let anima = useRef(null);
  let anima2 = useRef(null);
  let animaSpanRef = useRef(null);

  let backgroundCity = useRef(null);
  let backgroundPortraitCity = useRef(null);

  let homeFade = useRef(null);
  let portraitContent = useRef(null);
  useEffect(() => {
    gsap.to(backgroundBridal, {
      ///backgroundSize: "120%",
      scrollTrigger: {
        start: "top top",
        end: "bottom 100px",
        trigger: triggerUrbanima,
        // markers: true,
        scrub: 1
      }
    });
  });
  // useEffect(() => {
  //   gsap.from(homeFade, {
  //     opacity: 0,
  //     duration: 2,
  //     ease: "Power4.easeInOut"
  //   });
  //   gsap.from(sanyaGray, {
  //     opacity: 0,
  //     y: 150,
  //     filter: "grayscale(100%)",
  //     duration: 3,
  //     ease: "Power4.easeInOut"
  //   });
  //   gsap.from(sanyaMobileGray, {
  //     opacity: 0,
  //     y: 10,
  //     filter: "grayscale(100%)",
  //     duration: 2,
  //     ease: "Power4.easeInOut"
  //   });
  //   gsap.from(urb, {
  //     opacity: 0,
  //     x: -70,
  //     duration: 2,
  //     ease: "Power4.easeInOut"
  //   });
  //   gsap.from(urb2, {
  //     opacity: 0,
  //     x: -70,
  //     duration: 1.7,
  //     ease: "Power4.easeInOut"
  //   });
  //   gsap.from(urbSpanRef, {
  //     opacity: 0,
  //     x: -70,
  //     duration: 4,
  //     ease: "Power4.easeInOut"
  //   });
  //   gsap.from(anima, {
  //     opacity: 0,
  //     x: 70,
  //     duration: 2,
  //     ease: "Power4.easeInOut"
  //   });
  //   gsap.from(anima2, {
  //     opacity: 0,
  //     x: 70,
  //     ease: "Power4.easeInOut",
  //     duration: 1.7
  //   });
  //   gsap.from(animaSpanRef, {
  //     opacity: 0,
  //     x: 70,
  //     duration: 4,
  //     ease: "Power4.easeInOut"
  //   });
  //   gsap.from(backgroundCity, {
  //     scale: 0.8,
  //     opacity: 0,
  //     y: 100,
  //     ease: "Power4.easeInOut",
  //     duration: 1.7,
  //     delay: 0.4
  //   });
  //   gsap.from(backgroundPortraitCity, {
  //     scale: 1.3,
  //     opacity: 0,
  //     x: 70,
  //     ease: "Power4.easeInOut",
  //     duration: 1.7,
  //     delay: 0.4
  //   });
  //   gsap.from(headerRightBridalPortrait, {
  //     opacity: 0,
  //     x: 70,
  //     ease: "Power4.easeInOut",
  //     duration: 1.7,
  //     delay: 0.5
  //   });
  //   gsap.from(portraitContent, {
  //     opacity: 0,
  //     y: 70,
  //     ease: "Power4.easeInOut",
  //     duration: 1.7,
  //     delay: 0.5
  //   });
  // });

  return (
    <div ref={(el) => (homeFade = el)} className="bridal-desk-main">
      <div className="bridal-desk-header">
        <a href="https://www.teilor.ro/">
          <img
            ref={(el) => (triggerUrbanima = el)}
            className="logo"
            src={logo}
            alt=""
          />
        </a>
      </div>
      <div
        ref={(el) => (headerRightBridal = el)}
        className="bridal-desk-header-2"
      >
        <span className="bridal-span-1">ACCESORII</span> DE VARĂ
      </div>
      <div ref={(el) => (backgroundBridal = el)} className="bridal-desk-bg">
        <img
          ref={(el) => (backgroundCity = el)}
          className="background-city"
          src={DeskBg}
          alt=""
        />
        <img className="colier" src={Colier} alt="" />
        <img className="ring" src={RingImg} alt="" />
      </div>
      <div className="svg-holder">
        <div className="svg-header">
          <div className="urbanima-header-desktop">
            <div className="header-anim-desktop">
              <div ref={(el) => (urbSpanRef = el)} className="urb-span">
                <span>Summer</span>
              </div>
              <div className="anima-span" ref={(el) => (animaSpanRef = el)}>
                <span>GLOW</span>
              </div>
            </div>
          </div>
          <div className="svg-content">
            <p>
              Bijuterii versatile din aur, într-un mix de stiluri, forme și
              culori care îți accesorizează fiecare zi de vacanță. Îmbină-le și
              poartă-le cu încredere.
            </p>
            <div className="cta-colectie mobile-erase">
              {" "}
              <a href={"https://www.teilor.ro/urbanima.html"}>
                <div className="button1 home-cta-urbanima">
                  {" "}
                  DESCOPERĂ COLECȚIA{" "}
                </div>
              </a>
            </div>
          </div>

          {/* <img
            ref={(el) => (sanyaGray = el)}
            className="sanya-home"
            src={sanya}
          /> */}
        </div>
      </div>

      <div className="urbanima-portrait-content">
        <div className="bridal-desk-header-portrait">
          <img
            ref={(el) => (triggerUrbanima = el)}
            className="logo"
            alt=""
            src={logo}
          />
        </div>
        <div className="div-height"></div>
        <div className="urbanima-portrait-row-1">
          <div className="bridal-portrait-bg">
            <img
              ref={(el) => (backgroundPortraitCity = el)}
              src={PortraitBg}
              alt=""
            />
            <img className="colier" src={Colier} alt="" />
            <img className="ring" src={RingImg} alt="" />
          </div>

          <div
            ref={(el) => (headerRightBridalPortrait = el)}
            className="bridal-desk-header-2-portrait"
          >
            <p>
              <span>ACCESORII </span> DE VARĂ
            </p>
          </div>

          <div className="urbanima-portrait-img"></div>
        </div>
        <div className="urbanima-header-portrait">
          <div className="header-anim-portrait">
            <div ref={(el) => (urbSpanRef = el)} className="urb-span">
              <span>Summer</span>
            </div>
            <div className="anima-span" ref={(el) => (animaSpanRef = el)}>
              <span>GLOW</span>
            </div>
          </div>
        </div>
        <div
          ref={(el) => (portraitContent = el)}
          className="urbanima-portrait-row-2"
        >
          <div className="urbanima-portrait-text">
            <p>
              Bijuterii versatile din aur, într-un mix de stiluri, forme și
              culori care îți accesorizează fiecare zi de vacanță. Îmbină-le și
              poartă-le cu încredere.
            </p>
          </div>
          <div className="col-1 mobile-erase">
            <div className="cta-colectie">
              {" "}
              <a href="https://www.teilor.ro/urbanima.html">
                <div className="button1"> DESCOPERĂ COLECȚIA</div>
              </a>
            </div>
          </div>
          <div className="col-1 mobile-reveal">
            <div className="cta-colectie">
              {" "}
              <a href="https://www.teilor.ro/urbanima.html">
                <div className="button1"> DESCOPERĂ COLECȚIA</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
